import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAppGroupIdCampaignQa } from "./constants";
import type {
  PostwsGenerativeAiAppGroupIdCampaignQaPayload,
  PostwsGenerativeAiAppGroupIdCampaignQaProps,
} from "./types";
import { isCampaignQaResult } from "./validators";

export const postwsGenerativeAiAppGroupIdCampaignQa = reactQueryPostWebsocketAdapter(
  generativeAiAppGroupIdCampaignQa,
  async (
    signal,
    { appGroupId, agentIds, campaignDocument, jobToken }: PostwsGenerativeAiAppGroupIdCampaignQaProps
  ): Promise<{}> => {
    const payload: PostwsGenerativeAiAppGroupIdCampaignQaPayload = {
      job_token: jobToken,
      agent_ids: agentIds,
      campaign_document: campaignDocument,
    };

    return await fetch(
      `/${appGroupId}/generative_ai/campaign_qa`,
      "POST",
      payload,
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  },
  isCampaignQaResult
);
